/**
 * @file automatically generated from MApp.Data.BrowserRuntimeType
 */

export enum BrowserRuntimeType {
    MapViewer = 1,
    BiMapViewer = 2,
    FeatureAnalyzer = 3,
    Workflow = 4,
    CustomPanel = 5
}
